import { motion } from 'framer-motion'
import { Linkedin, Mail, Github } from 'lucide-react'

const Team = () => {
  const teamMembers = [
    {
      name: 'Nahid Islam',
      role: 'Founder & Lead Engineer',
      description: 'IoT Engineer, Full-Stack Web Developer and Android/iOS Developer',
      image: '/profile.jpg',
      social: {
        linkedin: 'https://www.linkedin.com/in/nahidislamecehstu/',
        email: 'mailto:ni749954@gmail.com',
        github: 'https://github.com/nahidislam106'
      }
    },
    {
      name: 'Harun Or Rashid',
      role: 'Co-Founder & Hardware Specialist',
      description: 'IoT Expert and Embedded Systems Developer',
      image: '/harun.png',
      social: {
        linkedin: '',
        email: 'mailto:hroshid747@gmail.com',
        github: ''
      }
    },
    {
      name: 'Romjan Ali',
      role: 'Project Planner & Projects Coordinator',
      description: 'Expert in project planning, coordination, and execution, ensuring timely delivery and smooth collaboration across all IoT and software projects.',
      image: '/Romjan.png', // Add the image to public/ if available
      social: {
        linkedin: '',
        email: 'mailto:romjanali6474@gmail.com',
        github: ''
      }
    },
     {
      name: 'Mofassel Hossain Rana',
      role: 'UI/UX Designer & Frontend Developer',
      description: 'Specialist in crafting user-friendly interfaces and seamless user experiences for web and mobile applications.',
      image: '/rana.png', // Add the image to public/ if available
      social: {
        linkedin: '',
        email: '',
        github: ''
      }
    }
    ,
    {
      name: 'Asif Iqbal Muhin',
      role: 'Frontend Developer',
      description: 'Passionate Frontend Developer skilled in building responsive and interactive web applications, dedicated to delivering seamless user experiences with modern technologies.',
      image: '/muhin.png', 
      social: {
        linkedin: 'https://www.linkedin.com/in/asif-iqbal-muhin-22a6683a0/',
        email: 'mailto:olindoasif@gmail.com',
        github: 'https://github.com/asifolindo'
      }
    }
  ]

  return (
    <section id="team" className="py-20 px-6 bg-slate-900/60">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
              Meet our Team
            </span>
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            We create innovative IoT and software solutions.
          </p>
        </motion.div>

        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full">
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                whileHover={{ y: -10 }}
                className="glass-card p-8 text-center group hover:bg-white/10 transition-all duration-300 w-full"
              >
                <div className="relative inline-block mb-6">
                  <motion.img
                    src={member.image}
                    alt={member.name}
                    className="w-40 h-40 mx-auto rounded-full object-cover border-4 border-blue-400/50 shadow-xl"
                    whileHover={{ scale: 1.1 }}
                    transition={{ duration: 0.3 }}
                  />
                  <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500/20 to-purple-500/20 blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                </div>

                <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-400 transition-colors">
                  {member.name}
                </h3>
                <p className="text-base text-blue-400 font-medium mb-3">{member.role}</p>
                <p className="text-sm text-white/60 mb-6 leading-relaxed">
                  {member.description}
                </p>

                <div className="flex justify-center gap-3">
                  <motion.a
                    href={member.social.linkedin}
                    whileHover={{ scale: 1.2, rotate: 5 }}
                    whileTap={{ scale: 0.9 }}
                    className="p-2 bg-white/5 hover:bg-blue-500/20 rounded-lg transition-colors"
                  >
                    <Linkedin size={18} />
                  </motion.a>
                  <motion.a
                    href={member.social.email}
                    whileHover={{ scale: 1.2, rotate: -5 }}
                    whileTap={{ scale: 0.9 }}
                    className="p-2 bg-white/5 hover:bg-blue-500/20 rounded-lg transition-colors"
                  >
                    <Mail size={18} />
                  </motion.a>
                  <motion.a
                    href={member.social.github}
                    whileHover={{ scale: 1.2, rotate: 5 }}
                    whileTap={{ scale: 0.9 }}
                    className="p-2 bg-white/5 hover:bg-blue-500/20 rounded-lg transition-colors"
                  >
                    <Github size={18} />
                  </motion.a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Team
